import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';
import { Observable } from 'rxjs';
import { StatisticsDaily } from '../../public_api';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/statistics`;
  }

  getDaily(dataName: StatisticsDaily, startDate: string, endDate: string): Observable<any[][]> {
    return this.httpClient.get<any[][]>(`${this._baseURL}/${dataName}`, {
      params: { startDate, endDate }
    });
  }

}
